import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../../components/Header';
import { Box, Button, Grid, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getAssignInPayment, getFabricator, getInstallerInFab, getuserInFab, updateFabricatorStatus } from '../../../redux/slice/fabricator.slice';
import { getElectrician, updateElectricianStatus } from '../../../redux/slice/electrician.slice';
import { useSnackbar } from 'notistack';

function Payment() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const getuserId = localStorage.getItem("id");
  const users = useSelector(state => state.fabricator.Userfab).find((a) => a._id === getuserId);
  const AllFabricator = useSelector(state => state.fabricator.Fabricator) || [];
  const AllElectrician = useSelector(state => state.electrician.Electrician) || [];
  const userRole = users?.roleData?.[0]?.roleName;
  const AssignInstaller = useSelector(state => state.fabricator.assignpayment) || [];
  const FabricatorRate = Array.isArray(AllFabricator) ? AllFabricator.filter(a => a.TotalAmount > 0) : [];
  const ElectricianRate = Array.isArray(AllElectrician) ? AllElectrician.filter(a => a.TotalAmount > 0) : [];

  const filteredFabricatorRate = AssignInstaller?.filter(assign => {
    const isFabricatorMatch = FabricatorRate?.some(rate => rate.assignId === assign?._id);
    const isSuperAdmin = userRole === 'Super Admin';
    const isUserMatch = assign.Fabricator === users?._id;
    return isFabricatorMatch && (isSuperAdmin || isUserMatch);
  });




  const filteredElectricianRate = AssignInstaller?.filter(assign => {
    const isElectricianMatch = ElectricianRate?.some(rate => rate.assignId === assign?._id);
    const isSuperAdmin = userRole === 'Super Admin';
    const isUserMatch = assign.Electrician === users?._id;
    return isElectricianMatch && (isSuperAdmin || isUserMatch);
  });



  const currentDate = new Date();
  const isPeriodDisabled = (endDate) => {
    const endDateTime = new Date(endDate);
    return endDateTime <= currentDate && endDateTime <= new Date(currentDate.getFullYear(), currentDate.getMonth(), 25);
  };

  const isSubmittingRef = useRef(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(getAssignInPayment())
    dispatch(getuserInFab());
    dispatch(getFabricator());
    dispatch(getElectrician());
  }, [dispatch, isSubmitting]);





  const handleSubmit = async (type, ids) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    const submitDate = new Date().toISOString();




    if (Array.isArray(ids)) {
      // for (const id of ids) {
      if (type === 'Fabricator') {
        handleUpdateFabricatorStatus(ids, submitDate);
      }
      if (type === 'Electrician') {
        handleUpdateElectricianStatus(ids, submitDate);
      }

      // }
    } else {
      if (type === 'Fabricator') {
        handleUpdateFabricatorStatus(ids, submitDate);
      }
      if (type === 'Electrician') {
        handleUpdateElectricianStatus(ids, submitDate);
      }

    }

    setIsSubmitting(true);
    isSubmittingRef.current = true;
  }

  const handleUpdateFabricatorStatus = (ids, submitDate) => {
    dispatch(updateFabricatorStatus({ ids, submitDate }));
    dispatch(getInstallerInFab());
    dispatch(getFabricator());
  };

  const handleUpdateElectricianStatus = (ids, submitDate) => {
    dispatch(updateElectricianStatus({ ids, submitDate }));
    dispatch(getInstallerInFab());
    dispatch(getElectrician());
  };



  const [selectedYear, setSelectedYear] = useState('Select Year');
  const [selectedMonth, setSelectedMonth] = useState('Select Month');
  const [selectedRole, setSelectedRole] = useState('Select Role');


  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const GroundFabricator = (data) => {
    const arr = Array.isArray(data) ? data : [];
    return arr.reduce((acc, item) => {
      const key = item.billNo ? item.billNo : 'no-bill';
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});
  };


  const GroundElectrician = (data) => {
    return data?.reduce((acc, item) => {
      const key = item.billNo ? item.billNo : 'no-bill';
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});
  };

  // A file can have legacy duplicate fabricator entries. Keep the billed or
  // paid entry so it cannot be displayed again in a later pending invoice.
  const getFabricatorRecordPriority = (record) => {
    if (record?.requestStatus === 'Complete' || record?.paymentAmount > 0 || record?.billNo !== undefined) return 2;
    if (record?.requestStatus === 'Approved') return 1;
    return 0;
  };

  const uniqueFabricatorByFile = Array.from(
    AllFabricator.reduce((recordsByFile, record) => {
      const fileKey = record?.marketData?.[0]?._id || record?.marketData?.[0]?.fillNo;

      if (!fileKey) {
        recordsByFile.set(record._id, record);
        return recordsByFile;
      }

      const existingRecord = recordsByFile.get(String(fileKey));
      if (!existingRecord || getFabricatorRecordPriority(record) > getFabricatorRecordPriority(existingRecord)) {
        recordsByFile.set(String(fileKey), record);
      }
      return recordsByFile;
    }, new Map()).values()
  );

  const groupedFabricatorRate = GroundFabricator(uniqueFabricatorByFile);
  // A file can have legacy duplicate electrician entries. Keep the billed or
  // paid entry so it cannot be displayed again in a later pending invoice.
  const getElectricianRecordPriority = (record) => {
    if (record?.requestStatus === 'Complete' || record?.paymentAmount > 0 || record?.billNo !== undefined) return 2;
    if (record?.requestStatus === 'Approved') return 1;
    return 0;
  };

  const uniqueElectricianByFile = Array.from(
    AllElectrician.reduce((recordsByFile, record) => {
      const fileKey = record?.marketData?.[0]?._id || record?.marketData?.[0]?.fillNo;

      if (!fileKey) {
        recordsByFile.set(record._id, record);
        return recordsByFile;
      }

      const existingRecord = recordsByFile.get(String(fileKey));
      if (!existingRecord || getElectricianRecordPriority(record) > getElectricianRecordPriority(existingRecord)) {
        recordsByFile.set(String(fileKey), record);
      }
      return recordsByFile;
    }, new Map()).values()
  );
  const groupedElectricianRate = GroundElectrician(uniqueElectricianByFile);

  console.log("GroundElectrician", groupedElectricianRate);


  // const sortedFab = Object.entries(groupedFabricatorRate).sort((a, b) =>
  //   new Date(b[1].endDate) - new Date(a[1].endDate)
  // );

  const sortedFab = Object.entries(groupedFabricatorRate)
    .map(([key, records]) => ({
      key,
      data: records.filter((item, itemIndex, self) =>
        // Ensure marketData and its first element exist before accessing fillNo
        item.marketData && item.marketData[0] &&
        self.findIndex(t =>
          t.marketData && t.marketData[0] && t.marketData[0].fillNo === item.marketData[0].fillNo
        ) === itemIndex
      )
    }))
    .sort((a, b) => {
      if (a.key === "no-bill") return -1;
      if (b.key === "no-bill") return 1;

      const latestA = new Date(a.data[0].submitDate);
      const latestB = new Date(b.data[0].submitDate);
      return latestB - latestA; // descending
    });

  // const sortedEle = Object.entries(groupedElectricianRate).sort((a, b) =>
  //   new Date(b[1].endDate) - new Date(a[1].endDate)
  // );

  const sortedEle = Object.entries(groupedElectricianRate)
    .map(([key, records]) => ({
      key,
      data: records.filter((item, itemIndex, self) =>
        // Ensure marketData and its first element exist before accessing fillNo
        item.marketData && item.marketData[0] &&
        self.findIndex(t =>
          t.marketData && t.marketData[0] && t.marketData[0].fillNo === item.marketData[0].fillNo
        ) === itemIndex
      )
    }))
    .sort((a, b) => {
      if (a.key === "no-bill") return -1;
      if (b.key === "no-bill") return 1;

      const latestA = new Date(a.data[0].submitDate);
      const latestB = new Date(b.data[0].submitDate);
      return latestB - latestA; // descending
    })

  console.log("Invoice DatInvoice Dat", sortedEle);




  return (
    <Box m="2px">
      <Header title="PAYMENT" subtitle="Manage Your Payment Here" />

      <Box display="flex" justifyContent="space-between" flexDirection={{ xs: 'column', sm: 'row', md: 'row' }}>
        <div style={{ margin: '0 10px', flex: 1 }}>
          <Select
            value={selectedMonth}
            onChange={handleMonthChange}
            displayEmpty
            sx={{
              minWidth: '100%',
              [theme.breakpoints.up('sm')]: {
                minWidth: '200px',
              },
              marginBottom: '20px',
              '& .MuiSelect-select': {
                padding: '8px',
                border: 'none',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
                borderWidth: '2px',
              },
            }}
          >
            <MenuItem value="Select Month">Select Month</MenuItem>
            {['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map((month, index) => (
              <MenuItem key={index} value={month}>{month}</MenuItem>
            ))}
          </Select>
          <Select
            value={selectedYear}
            onChange={handleYearChange}
            displayEmpty
            sx={{
              minWidth: '100%',
              [theme.breakpoints.up('sm')]: {
                minWidth: '200px',
              },
              marginBottom: '20px',
              marginLeft: { xs: 0, md: '20px' },
              '& .MuiSelect-select': {
                padding: '8px',
                border: 'none',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
                borderWidth: '2px',
              },
            }}
          >
            <MenuItem value="Select Year">Select Year</MenuItem>
            {Array.from({ length: 31 }, (_, index) => 2020 + index).map(year => (
              <MenuItem key={year} value={year}>{year}</MenuItem>
            ))}
          </Select>
        </div>
        <div style={{ margin: '0 10px', flexShrink: 0 }}>
          <Select
            value={selectedRole}
            onChange={handleRoleChange}
            displayEmpty
            sx={{
              minWidth: '100%',
              [theme.breakpoints.up('sm')]: {
                minWidth: '200px',
              },
              marginBottom: '20px',
              '& .MuiSelect-select': {
                padding: '8px',
                border: 'none',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#566585',
                borderWidth: '2px',
              },
            }}
          >
            <MenuItem value="Select Role">Select Role</MenuItem>
            <MenuItem value="Fabricator">Fabricator</MenuItem>
            <MenuItem value="Electrician">Electrician</MenuItem>
          </Select>
        </div>
      </Box>

      {(selectedRole === 'Select Role' || selectedRole === 'Fabricator') && (
        <>
          <Typography variant="h4" fontWeight="600">Fabricator</Typography>
          {sortedFab.length > 0 ? (
            <>
              {sortedFab?.map(({ key, data }, index) => {

                
                

                const fabricatedata = data?.map(item => item?.eledata?.[0]);
                const FabricatorName = data[0]?.assignInstallerData[0]?.febricianName;

                console.log("data[0]?.assignInstallerData[0]?.", data[0]?.assignInstallerData[0]);


                let totalAmt = data?.reduce((acc, v) => acc + parseFloat(v?.TotalAmount), 0);
                let givenAmt = data?.reduce((acc, v) => {
                  const amount = parseFloat(v?.paymentAmount ?? 0);
                  const tds = parseFloat(v?.tds ?? 0);
                  return acc + amount + tds;
                }, 0);

                const latestDate = data
                  ?.map(e => new Date(e?.paymentDate))
                  .filter(date => !isNaN(date)) // remove invalid dates
                  .sort((a, b) => b - a)[0];

                const formattedLatestDate = latestDate?.toLocaleDateString();

                return (
                  <Box key={index} sx={{
                    m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2,
                    bgcolor: theme.palette.mode === 'dark' ? '#293040' : "#E5F1FD",
                    color: theme.palette.mode === 'dark' ? 'white' : "black",
                  }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Box sx={{
                          fontSize: '14px',
                          fontWeight: '600',
                          display: 'flex',
                          justifyContent: 'space-between',
                          overflowX: 'auto',
                          whiteSpace: 'nowrap',
                          '& > *:not(:last-child)': {
                            marginRight: '25px',
                          }
                        }}>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            Invoice Date: {data[0]?.submitDate ? new Date(data[0]?.submitDate)?.toLocaleDateString() : new Date()?.toLocaleDateString()}
                          </Typography>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            Invoice No:
                            {`Fabricator/${FabricatorName}/${data[0]?.submitDate ? new Date(data[0]?.submitDate)?.toLocaleDateString() : new Date()?.toLocaleDateString()}/${key}`}
                          </Typography>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            Status: {givenAmt >= totalAmt ? 'Complete' : "Pending"}
                          </Typography>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            Date of Payment: {formattedLatestDate}
                          </Typography>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            Fabricator Name: {FabricatorName}
                          </Typography>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            <Button variant='contained' color='primary' disabled={isSubmitting} sx={{
                              opacity: data?.some(a => a?.requestStatus === "Pending") ? 1 : 0.5,
                              pointerEvents: data?.some(a => a?.requestStatus === "Pending") ? "auto" : "none",

                            }} onClick={() => handleSubmit('Fabricator', data?.map(a => a._id))}>
                              Send to Account
                            </Button>
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <TableContainer>
                          <Table style={{ width: '100%' }}>
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>File No</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>Name</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>City</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>Dealer Name</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>System Size</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>Rate / KW</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>Fabricator Amount</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>Account Payable</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {data.map((rate, index) => {
                                const marketData = rate?.marketData?.[0];

                                return (
                                  <TableRow key={index}>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{marketData?.fillNo}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{marketData?.ConsumerName}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{marketData?.City_Village}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{rate?.assignInstallerData[0]?.febricianName}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{rate?.SystemSize}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{rate?.RateKw}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                      {Number(rate?.TotalAmount || 0).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                      {rate?.paymentAmount + rate?.tds || 0}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                              <TableRow>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Total Amount</TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                  {Number(totalAmt).toFixed(2)}
                                </TableCell>
                                <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                  {givenAmt || 0}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </Box>
                )
              })}
            </>
          ) : (
            <Typography variant="h6" color="textSecondary" align="center" sx={{ mt: 4 }}>
              No Data Availble
            </Typography>
          )}
        </>
      )}

      {(selectedRole === 'Select Role' || selectedRole === 'Electrician') && (
        <>
          <Typography variant="h4" fontWeight="600">Electrician</Typography>
          {sortedEle?.length > 0 ? (
            <>
              {sortedEle?.map(({ key, data }, index) => {
               

                const electricianName = data[0]?.assignInstallerData[0]?.electricianName;

                if (key == 16) {
console.log("key, dataxxxxxx", key, data);
                }

                let totalAmt = data?.reduce((acc, v) => acc + parseFloat(v?.TotalAmount), 0);
                let givenAmt = data?.reduce((acc, v) => {
                  const amount = parseFloat(v?.paymentAmount ?? 0);
                  const tds = parseFloat(v?.tds ?? 0);
                  return acc + amount + tds;
                }, 0);

                const latestDate = data
                  ?.map(e => new Date(e?.paymentDate))
                  .filter(date => !isNaN(date)) // remove invalid dates
                  .sort((a, b) => b - a)[0];

                const formattedLatestDate = latestDate?.toLocaleDateString();

                console.log("ddddddmm", data)
                return (
                  <Box key={index} sx={{
                    m: 3, ml: 0, mr: 0, p: 3, borderRadius: 2,
                    bgcolor: theme.palette.mode === 'dark' ? '#293040' : "#E5F1FD",
                    color: theme.palette.mode === 'dark' ? 'white' : "black",
                  }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Box sx={{
                          fontSize: '14px',
                          fontWeight: '600',
                          display: 'flex',
                          justifyContent: 'space-between',
                          overflowX: 'auto',
                          whiteSpace: 'nowrap',
                          '& > *:not(:last-child)': {
                            marginRight: '25px',
                          }
                        }}>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            Invoice Date: {data[0]?.submitDate ? new Date(data[0]?.submitDate)?.toLocaleDateString() : new Date()?.toLocaleDateString()}
                          </Typography>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            Invoice No:
                            {`Electrician/${electricianName}/${data[0]?.submitDate ? new Date(data[0]?.submitDate)?.toLocaleDateString() : new Date()?.toLocaleDateString()}/${key}`}
                          </Typography>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            Status: {givenAmt >= totalAmt ? 'Complete' : "Pending"}
                          </Typography>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            Date of Payment: {formattedLatestDate}
                          </Typography>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            Electrician Name: {electricianName}
                          </Typography>

                          <Typography variant="h6" sx={{ mb: 2 }}>
                            <Button variant='contained' color='primary' disabled={isSubmitting} sx={{
                              opacity: data?.some(a => a?.requestStatus === "Pending") ? 1 : 0.5,
                              pointerEvents: data?.some(a => a?.requestStatus === "Pending") ? "auto" : "none",
                            }} onClick={() => handleSubmit('Electrician', data?.map(a => a._id))}>
                              Send to Account
                            </Button>
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <TableContainer>
                          <Table style={{ width: '100%' }}>
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>File No</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>Name</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>City</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>Dealer Name</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>System Size</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>Rate / KW</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>Electrician Amount</TableCell>
                                <TableCell sx={{ fontSize: '15px', fontWeight: '600' }}>Account Payable</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {
                                
                                
                                data.map((rate, index) => {
                                  console.log("rate",rate);
                                  
                                  const marketData = rate?.marketData?.[0];

                                  if (key == 20) {
console.log("key, dataxxxxxx marketData", rate?.data);
                                  }

                                  return (
                                    <TableRow key={index}>
                                      <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{marketData?.fillNo}</TableCell>
                                      <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{marketData?.ConsumerName}</TableCell>
                                      <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{marketData?.City_Village}</TableCell>
                                      <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{rate?.assignInstallerData[0]?.electricianName}</TableCell>
                                      <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{rate?.SystemSize}</TableCell>
                                      <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>{rate?.RateKw}</TableCell>
                                      <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                        {Number(rate?.TotalAmount || 0).toFixed(2)}
                                      </TableCell>
                                      <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                        {rate?.paymentAmount + rate?.tds || 0}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                            </TableBody>
                            <TableRow>
                              <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>Total Amount</TableCell>
                              <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                              <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                              <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                              <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                              <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}></TableCell>
                              <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                {Number(totalAmt).toFixed(2)}
                              </TableCell>
                              <TableCell sx={{ fontSize: '14px', fontWeight: '600' }}>
                                {givenAmt || 0}
                              </TableCell>
                            </TableRow>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </Box>
                )
              })}
            </>
          ) : (
            <Typography variant="h6" color="textSecondary" align="center" sx={{ mt: 4 }}>
              No Data Availble
            </Typography>
          )}
        </>
      )}


    </Box >
  );
}

export default Payment;
